import {LitElement, html} from 'lit';
import {property, customElement} from 'lit/decorators.js';
import {Service} from '../../service/service.js';
import {ElementUtil} from '../../utils/elementUtil.js';
import {BaseComponent} from '../basecomponent.js';

/* global customElements */
class NextPrevToolbar extends BaseComponent {
	
	static get properties() {
		return {
			data: {type: Array}
		};
	}
	
	constructor() {
		super();
		
		var nextprevToolbar = this;
		
		nextprevToolbar.data = [];
		
		setTimeout(function(){
			nextprevToolbar.init();
		});
	}
	
	render() {
		return html`
			<style>
				.toolbar {
					width: 100%;
					margin-top: 10px;
					margin-right: 10px;
					border-top: 1px solid darkgray;
				}
		
				.next {
					float: right;
				}			
			</style>
			<div class="toolbar">
				<span>
					<slot name="previous"></slot>
				</span>
				<span>
					<slot name="center"></slot>
				</span>
				<span class="next">
					<slot name="next"></slot>
				</span>
			</div>
		`;
	}
	
	init() {
		var nextprevToolbar = this;
				
		nextprevToolbar.previous = ElementUtil.create({
			tag: 'vaadin-button',
			slot: 'previous',
			itemid: 'pervious',
			theme: 'icon',			
			style: 'cursor: pointer;',
			disabled: true,
			children: [
				{
					tag: 'vaadin-icon',
					icon: 'lumo:chevron-left',
					slot: 'prefix'					
				},
				{
					tag: 'span',
					innerHTML: 'Previous'
				}
			],
			listeners: {
				click: function() {
					nextprevToolbar.selectedIndex--;
					var readyEvent = new CustomEvent('change', { detail: {
						index: nextprevToolbar.selectedIndex,
						item: nextprevToolbar.data[nextprevToolbar.selectedIndex]
					}});
					nextprevToolbar.dispatchEvent(readyEvent);
					nextprevToolbar.checkButtons();
				}
			}
		});
		
		nextprevToolbar.next = ElementUtil.create({
			tag: 'vaadin-button',
			slot: 'next',
			itemid: 'next',
			theme: 'icon',			
			style: 'cursor: pointer;',
			disabled: true,
			children: [
				{
					tag: 'vaadin-icon',
					icon: 'lumo:chevron-right',
					slot: 'suffix'
					
				},
				{
					tag: 'span',
					innerHTML: 'Next'
				}
			],
			listeners: {
				click: function() {
					nextprevToolbar.selectedIndex++;
					var readyEvent = new CustomEvent('change', { detail: {
						index: nextprevToolbar.selectedIndex,
						item: nextprevToolbar.data[nextprevToolbar.selectedIndex]
					}});
					nextprevToolbar.dispatchEvent(readyEvent);
					nextprevToolbar.checkButtons();
				}
			}
		});		
		
		nextprevToolbar.append(nextprevToolbar.previous);
		nextprevToolbar.append(nextprevToolbar.next);
		
		//fire ready
		var readyEvent = new CustomEvent('ready', { detail: '' });
		nextprevToolbar.dispatchEvent(readyEvent);
	}
	
	updateData(dataRecords) {
		var nextprevToolbar = this;
		
		//disable Buttons
		nextprevToolbar.previous.disabled = true;
		nextprevToolbar.next.disabled = true;
		
		nextprevToolbar.data = dataRecords;		
		if (dataRecords.length > 0) {
			if (!nextprevToolbar.selectedIndex) {
				nextprevToolbar.selectedIndex = 0;
			}
			nextprevToolbar.checkButtons();
		}
	}
	
	checkButtons() {
		var nextprevToolbar = this;
		nextprevToolbar.checkNext();
		nextprevToolbar.checkPrevious();
	}	
	
	checkNext() {
		var nextprevToolbar = this;
		if (nextprevToolbar.selectedIndex === nextprevToolbar.data.length-1) {
			nextprevToolbar.next.disabled = true;
		} else {
			nextprevToolbar.next.disabled = false;
		}
	}
	
	checkPrevious() {
		var nextprevToolbar = this;
		if (nextprevToolbar.selectedIndex === 0) {
			nextprevToolbar.previous.disabled = true;
		} else {
			nextprevToolbar.previous.disabled = false;
		}		
	}
	
	setSelectedRecord(field, value) {
		var nextprevToolbar = this;
		var index=0;
		
		nextprevToolbar.data.forEach(function(record){
			if (record[field] === value){
				nextprevToolbar.selectedIndex = index;
			}
			index++;
		});
		nextprevToolbar.checkButtons();		
	}
	
};
customElements.define('dl-nextprev-toolbar', NextPrevToolbar);

